import React from "react";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { GetMonthlyIncomeReportResponse } from "modules/counter/api/type";
import { PrintMonthlyIncomeReportPage } from "../pages/print-monthly-income-report.page";
import { PdfPrinterModal } from "modules/core/components/pdf-printer-modal.component";
import { Button, useDisclosure } from "@chakra-ui/react";

interface PrintMonthlyIncomeReportComponentProps {
  monthlyIncomeReport: GetMonthlyIncomeReportResponse;
  month: string;
  year: string;
}

export const PrintMonthlyIncomeReportComponent: React.FC<
  PrintMonthlyIncomeReportComponentProps
> = (props: PrintMonthlyIncomeReportComponentProps) => {
  const monthlyRegisterReport = `Monthly-Income-Report-${props.month}-${props.year}.pdf`;

  const Document = (
    <PrintMonthlyIncomeReportPage
      monthlyIncomeReport={props.monthlyIncomeReport}
      month={props.month}
      year={props.year}
    />
  );
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Button onClick={onOpen} colorScheme="blue">
        Print Report
      </Button>
      <PdfPrinterModal
        isOpen={isOpen}
        onOpen={onOpen}
        onClose={onClose}
        document={Document}
        fileName={monthlyRegisterReport}
      />
    </>
  );
};
